(function() {
  // Toggle Opacity Items
  const opacityElements = document.querySelectorAll('[data-anim-opacity]');
  
  if(opacityElements.length > 0) {
    console.log("🚀 ~ file: _global.js:4 ~ opacityElements:", opacityElements)
    const toggleOpacity = (element) => 
      element.classList.toggle('is-active--opacity');

    opacityElements?.forEach(element => 
      element.parentElement.addEventListener('click', () => toggleOpacity(element)));
  }
})();